import {syncTry} from '../syncTry';
import {asyncTry} from '../asyncTry';

function protectMethod<F>(handler: ErrorHandler, method: F, async: boolean): F {
  return async ? asyncTry.bind(null, handler, method) : syncTry.bind(null, handler, method);
}

interface FactorySettings<S> {
  service: S;
  methods: string[];
  handler: ErrorHandler;
  async?: boolean;
}

export function createProxy<S extends Service | AsyncService, K extends keyof S>(
  settings: FactorySettings<S>
): S {
  const {service, methods, handler, async} = settings;
  const proxy: S = {...service};

  methods.forEach((methodName: string) => {
    const originalMethod = proxy[methodName as K];
    if (!originalMethod) return;

    const protectedMethod = protectMethod<S[K]>(handler, originalMethod, async);
    proxy[methodName as K] = protectedMethod;
  });

  return proxy;
}
